/**
 * Verti DEU PL API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Insurance tariff.     * `Single`   - Single without child    * `Family`   - german: Familie
 */
export const PrivateLiabilityTariff = {
  Single: 'Single',
  Family: 'Family',
} as const;
export type PrivateLiabilityTariff = (typeof PrivateLiabilityTariff)[keyof typeof PrivateLiabilityTariff];
